import { all, call, fork, put, take } from 'redux-saga/effects';

import { handleSagaError } from '»utils/handleSagasError';

import { userAttributesServices } from './userAttributes.services';
import { userAttributesSlice } from './userAttributes.slice';

const getUserAttributesWorker = function* ({ id }) {
  try {
    const data = yield call(userAttributesServices.getUserAttributes, { id });

    yield put(
      userAttributesSlice.actions.saveUserAttribute({
        id,
        value: data[0].attributeValue,
      }),
    );
  } catch (error) {
    const handled = yield call(handleSagaError, error);
    if (!handled)
      yield put(userAttributesSlice.actions.getUserAttributesFailure());
  }
};

const getUserAttributesSaga = function* () {
  while (true) {
    const authorized = false;
    try {
      while (!authorized) {
        const data = yield take(
          userAttributesSlice.actions.getUserAttributesRequest.type,
        );
        const { id } = data.payload;
        yield call(getUserAttributesWorker, { id });
      }
    } catch {
      yield put(userAttributesSlice.actions.getUserAttributesFailure());
    }
  }
};

const setUserAttributeWorker = function* ({ id, value }) {
  try {
    yield call(userAttributesServices.setUserAttribute, {
      id,
      value,
    });

    yield put(
      userAttributesSlice.actions.saveUserAttribute({
        id,
        value,
      }),
    );
  } catch (error) {
    const handled = yield call(handleSagaError, error);
    if (!handled)
      yield put(userAttributesSlice.actions.setUserAttributeFailure());
  }
};

const setUserAttributeSaga = function* () {
  while (true) {
    const authorized = false;
    try {
      while (!authorized) {
        const data = yield take(
          userAttributesSlice.actions.setUserAttributeRequest.type,
        );
        const { id, value } = data.payload;

        yield call(setUserAttributeWorker, { id, value });
      }
    } catch {
      yield put(userAttributesSlice.actions.setUserAttributeFailure());
    }
  }
};

export const userAttributesSagas = function* () {
  try {
    yield all([fork(getUserAttributesSaga), fork(setUserAttributeSaga)]);
  } catch {}
};
